
import { Code } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "@/hooks/use-toast";
import { useSettings } from "@/providers/SettingsProvider";

export const DevModeSettings = () => {
  const { devMode, toggleDevMode } = useSettings();
  
  // Handle dev mode toggle
  const handleDevModeToggle = (enabled: boolean) => {
    toggleDevMode(enabled);
    
    toast({
      title: enabled ? "Developer Mode Enabled" : "Developer Mode Disabled",
      description: enabled 
        ? "Developer tools and features are now available" 
        : "Developer tools and features are now hidden",
      variant: "default",
    });
  };

  return (
    <div className="space-y-2">
      <label className="text-xs font-medium text-white/70 flex items-center">
        <Code className="h-3.5 w-3.5 mr-1.5" />
        Developer Mode
      </label>
      <div className="flex items-center justify-between">
        <span className="text-xs">
          {devMode ? "Dev mode enabled" : "Dev mode disabled"}
        </span>
        <Switch
          checked={devMode}
          onCheckedChange={handleDevModeToggle}
          className="data-[state=checked]:bg-green-500"
        />
      </div>
      <p className="text-xs text-white/50 italic">
        Enable developer tools and debugging features
      </p>
    </div>
  );
};
